import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {UserDomainService} from './user-domain.service';
import {Observable} from 'rxjs';


@Injectable()
export class UserDomainsInterceptor implements HttpInterceptor {

  constructor(private domainService: UserDomainService, private http: HttpClient) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const domain = this.domainService.selectedDomain();
    return next.handle(req.clone({
      setHeaders: {
        Accept: `application/json`,
        'X-DOMAIN': domain ? domain.id.toString() : '*'
      }
    }));
  }

}
